import { Chip } from "@mui/material";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Components.Merchant.AppProducts;

export const DefaultChip = () => {
  const { t } = useResource();

  return (
    <Chip
      component="span"
      label={t(RESOURCES.ProductAccordion.Default)}
      variant="outlined"
      size="small"
    />
  );
};
